import { compose, prop } from 'ramda';

import { GTAG } from '../actions/rgpd';

export const getRgpd = (state) => state.rgpd;
export const getRgpdVisibility = (state) => state.rgpd?.visible;
export const getRgpdOpened = (state) => state.rgpd?.opened;
export const getRgpdForceDisplay = (state) =>
  !state.main?.document?.disableRgpbBanner || state.rgpd?.forceDisplay;
export const getRgpdOptions = (state) => state.rgpd?.options;
export const getGTAGRgpdOptions = compose(prop(GTAG), getRgpdOptions);
